module.exports = __webpack_public_path__ + "static/img/app_push.517adcf.svg";